import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Editor from '@monaco-editor/react';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  Typography
} from '@mui/material';

import TopBar from '../../../../../components/utils/TopBar';

import { 
  CreateDueDiligenceBIZfusionWyzia, 
  UpdateDueDiligenceBIZfusionWyzia 
} from '../../../../../redux/actions/business/fusion/wyzia/dueDilligenceActions';

import style from "../../../../../global.scss";

const defaultCreateBody = {
  "clientID": "68f1a0d93bb2ddd85224d6d8",
  "subClientName": "subclient of Wyzia US",
  "subClientData": {
    "programManagerDetails": {
      "identificationNumber": "867522981",
      "programManagerName": "ACD Fintech",
      "contactName": "Harry Smith",
      "contactEmailAddress": "abc@hero.com"
    },
    "programParticipantDetails": {
      "entityDetails": {
        "legalName": "ABC Corporation",
        "identificationNumber": "867423981",
        "identificationType": "TIN",
        "programParticipantAttestation": true
      },
      "additionalDetails": {
        "dbaDetails": {
          "hasAnyDBA": true,
          "dbaName": "ABC"
        },
        "tradingDetails": {
          "publiclyTradedStockSymbol": "ABCD",
          "tradedExchange": "NYSE"
        },
        "cipExempt": true,
        "hasAnyBeneficialOwner": true,
        "beneficialOwnerExempt": true,
        "standardIndustryClassificationCode": "237312",
        "natureOfBusiness": "Payment platform",
        "legalStructure": "LLC",
        "countryOfFormation": "US",
        "countryOfPrimaryBusinessOperations": "US",
        "projectedAnnualRevenue": "1000000",
        "msbServices": true,
        "businessPhoneNumber": 5679871234,
        "address": {
          "addressType": "residential",
          "addressLine1": "123 main street",
          "addressLine2": "Suite 301",
          "city": "Hillsboro",
          "state": "OR",
          "zipCode": "97124",
          "country": "US"
        }
      },
      "attestorDetails": {
        "firstName": "John",
        "lastName": "Smith",
        "jobTitle": "Project Manager",
        "dateOfAttestation": "1998-08-23"
      },
      "beneficialOwnershipDetails": [
        {
          "beneficialOwnerFirstName": "John",
          "beneficialOwnerLastName": "Smith",
          "ownershipPercentage": 27.5,
          "identificationIssuingCountry": "US",
          "beneficialOwnerAddress": {
            "addressLine1": "122 main street",
            "addressLine2": "13",
            "city": "Hillsboro",
            "state": "OR",
            "zipCode": "97124",
            "country": "US",
            "addressType": "residential"
          },
          "beneficialOwnerIdentificationNumber": "123266129",
          "identificationType": "SSN",
          "beneficialOwnerDateOfBirth": "1998-08-23",
          "beneficialOwnerPhoneNumber": 5679871231
        }
      ],
      "controlPersonDetails": {
        "titleOfControlPerson": "CFO",
        "firstName": "Roy",
        "lastName": "Sterling",
        "controlPersonAddress": {
          "addressLine1": "3400 John place",
          "addressLine2": "123 n central",
          "city": "Hillsboro",
          "state": "OR",
          "zipCode": "97124",
          "country": "US",
          "addressType": "residential"
        },
        "controlPersonPhoneNumber": 5671121231,
        "controlPersonDateOfBirth": "1998-08-23",
        "identificationNumber": "861273981",
        "identificationType": "SSN",
        "identificationIssuingCountry": "US"
      }
    }
  }
};

const defaultUpdateBody = {
  "subClientID": "68f1a0d93bb2ddd85224d6d8",
  "subClientData": {
    "programManagerDetails": {
      "identificationNumber": "867522981",
      "programManagerName": "ACD Fintech",
      "contactName": "Harry Smith",
      "contactEmailAddress": "abc@hero.com"
    },
    "programParticipantDetails": {
      "entityDetails": {
        "legalName": "ABC Corporation",
        "identificationNumber": "867423981",
        "identificationType": "TIN",
        "programParticipantAttestation": true
      },
      "additionalDetails": {
        "dbaDetails": {
          "hasAnyDBA": true,
          "dbaName": "ABC"
        },
        "tradingDetails": {
          "publiclyTradedStockSymbol": "ABCD",
          "tradedExchange": "NYSE"
        },
        "cipExempt": true,
        "hasAnyBeneficialOwner": true,
        "beneficialOwnerExempt": true,
        "standardIndustryClassificationCode": "237312",
        "natureOfBusiness": "Payment platform",
        "legalStructure": "LLC",
        "countryOfFormation": "US",
        "countryOfPrimaryBusinessOperations": "US",
        "projectedAnnualRevenue": "1000000",
        "msbServices": true,
        "businessPhoneNumber": 5679871234,
        "address": {
          "addressType": "residential",
          "addressLine1": "123 main street",
          "addressLine2": "Suite 301",
          "city": "Hillsboro",
          "state": "OR",
          "zipCode": "97124",
          "country": "US"
        }
      },
      "attestorDetails": {
        "firstName": "John",
        "lastName": "Smith",
        "jobTitle": "Project Manager",
        "dateOfAttestation": "1998-08-23"
      },
      "beneficialOwnershipDetails": [
        {
          "beneficialOwnerFirstName": "John",
          "beneficialOwnerLastName": "Smith",
          "ownershipPercentage": 27.5,
          "identificationIssuingCountry": "US",
          "beneficialOwnerAddress": {
            "addressLine1": "122 main street",
            "addressLine2": "13",
            "city": "Hillsboro",
            "state": "OR",
            "zipCode": "97124",
            "country": "US",
            "addressType": "residential"
          },
          "beneficialOwnerIdentificationNumber": "123266129",
          "identificationType": "SSN",
          "beneficialOwnerDateOfBirth": "1998-08-23",
          "beneficialOwnerPhoneNumber": 5679871231
        }
      ],
      "controlPersonDetails": {
        "titleOfControlPerson": "CFO",
        "firstName": "Roy",
        "lastName": "Sterling",
        "controlPersonAddress": {
          "addressLine1": "3400 John place",
          "addressLine2": "123 n central",
          "city": "Hillsboro",
          "state": "OR",
          "zipCode": "97124",
          "country": "US",
          "addressType": "residential"
        },
        "controlPersonPhoneNumber": 5671121231,
        "controlPersonDateOfBirth": "1998-08-23",
        "identificationNumber": "861273981",
        "identificationType": "SSN",
        "identificationIssuingCountry": "US"
      }
    }
  }
};

const DueDilligencePage = () => {
  const dispatch = useDispatch();
  const createEditorRef = useRef(null);
  const updateEditorRef = useRef(null);
  const [creating, setCreating] = useState(false);
  const [updating, setUpdating] = useState(false);

  function handleCreateEditorDidMount(editor, monaco) {
    createEditorRef.current = editor;
    editor.getAction('editor.action.formatDocument').run();
  }

  function handleUpdateEditorDidMount(editor, monaco) {
    updateEditorRef.current = editor;
    editor.getAction('editor.action.formatDocument').run();
  }

  const getEditorValue = (editorRef) => {
    try {
      const raw = editorRef.current.getValue();
      return JSON.parse(raw);
    } catch (err) {
      toast.error("Invalid JSON — please fix the payload before submitting.");
      return null;
    }
  };

  const handleCreate = () => {
    const payload = getEditorValue(createEditorRef);
    if (!payload) return;

    console.log("Create Payload:", payload);  

    dispatch(CreateDueDiligenceBIZfusionWyzia(payload, setCreating));
  };

  const handleUpdate = () => {
    const payload = getEditorValue(updateEditorRef);
    if (!payload) return;

    console.log("Update Payload:", payload);  

    dispatch(UpdateDueDiligenceBIZfusionWyzia(payload, setUpdating));
  };

  return (
    <Box>
      <TopBar title="Due Diligence" />

      <Box
        display="flex"
        gap={3}
        padding={3}
        sx={{ flexDirection: { xs: "column", lg: "row" } }}
      >
        {/* ── Create Section ── */}
        <Box flex={1} display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6" sx={{ color: style["primary"] }}>
            Create Due Diligence
          </Typography>
          <Divider />
          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              overflow: "hidden"
            }}
          >
            <Editor
              height="60vh"
              defaultLanguage="json"
              defaultValue={JSON.stringify(defaultCreateBody, null, 2)}
              theme="vs-dark"
              onMount={handleCreateEditorDidMount}
              options={{
                wordWrap: "on",
                formatOnPaste: true,
                formatOnType: true,
                minimap: { enabled: false },
                scrollBeyondLastLine: false,
              }}
            />
          </Box>
          <Button
            variant="contained"
            disabled={creating}
            onClick={handleCreate}
            sx={{ alignSelf: "flex-end" }}
          >
            {creating ? "Creating..." : "Create Due Diligence"}
          </Button>
        </Box>

        {/* ── Update Section ── */}
        <Box flex={1} display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6" sx={{ color: style["primary"] }}>
            Update Due Diligence
          </Typography>
          <Divider />
          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              overflow: "hidden"
            }}
          >
            <Editor
              height="60vh"
              defaultLanguage="json"
              defaultValue={JSON.stringify(defaultUpdateBody, null, 2)}
              theme="vs-dark"
              onMount={handleUpdateEditorDidMount}
              options={{
                wordWrap: "on",
                formatOnPaste: true,
                formatOnType: true,
                minimap: { enabled: false },
                scrollBeyondLastLine: false,
              }}
            />
          </Box>
          <Button
            variant="contained"
            disabled={updating}
            onClick={handleUpdate}
            sx={{ alignSelf: "flex-end" }}
          >
            {updating ? "Updating..." : "Update Due Diligence"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DueDilligencePage;